// src/theme/mantineTheme.ts
import { MantineThemeOverride } from '@mantine/core';
import { myTheme } from './theme';
import { alpha, darken } from '@mui/material';

export const theme: MantineThemeOverride = {
    colorScheme: 'light',
    primaryColor: 'brand',
    fontFamily: myTheme.typography.fontFamily,
    defaultRadius: 'md',
    headings: {
        fontFamily: myTheme.typography.fontFamily,
        fontWeight: '700',
    },
    colors: {
        brand: [
            alpha(myTheme.primary.main, 0.4), //lightest
            alpha(myTheme.primary.main, 0.5),
            alpha(myTheme.primary.main, 0.6),
            alpha(myTheme.primary.main, 0.7),
            alpha(myTheme.primary.main, 0.8),
            alpha(myTheme.primary.main, 0.9),
            alpha(myTheme.primary.main, 0.9), //original
            darken(myTheme.primary.main, 0.1),
            darken(myTheme.primary.main, 0.2),
            darken(myTheme.primary.main, 0.3), //darkest
        ],
    },

    components: {
        Button: {
            styles: () => ({
                root: {
                    fontWeight: 600,
                    fontFamily: myTheme.typography.fontFamily,
                    color: myTheme.textAccent.main,
                    '&:hover': {
                        backgroundColor: myTheme.textAccent.contrastText,
                    },
                },
            }),
        },
        Chip: {
            styles: () => ({
                root: {
                    fontFamily: myTheme.typography.fontFamily,
                },
            }),
        },
        Tooltip: {
            styles: () => ({
                tooltip: {
                    fontFamily: myTheme.typography.fontFamily,
                },
            }),
        },
        Alert: {
            styles: () => ({
                root: {
                    backgroundColor: myTheme.warning.main,
                    fontFamily: myTheme.typography.fontFamily,
                },
            }),
        },
        ActionIcon: {
            styles: () => ({
                root: {
                    color: myTheme.textAccent.main,
                },
            }),
        },
    },
};
